export default {
  labels: {
    es: {
      labelPrevDecade: 'Década anterior',
      labelPrevYear: 'Año anterior',
      labelPrevMonth: 'Mes anterior',
      labelCurrentMonth: 'Mes actual',
      labelNextMonth: 'Mes siguiente',
      labelNextYear: 'Año siguiente',
      labelNextDecade: 'Década siguiente',
      labelToday: 'Hoy',
      labelSelected: 'Fecha seleccionada',
      labelNoDateSelected: 'Sin fecha seleccionada',
      labelCalendar: 'Calendario',
      labelNav: 'Navegación calendario',
      labelHelp: 'Use las teclas del cursor para navegar por las fechas del calendario',
      labelReset: 'Borrar',
      'label-today-button': 'Hoy',
      'label-reset-button': 'Borrar',
      'label-close-button': 'Cerrar'
    }
  }
};
